<template>
  <div class="bar-chart-container">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  name: 'CallLogByDateBarChart',
  props: {
    callLogs: {
      type: Array,
      required: true,
    },
  },
  methods: {
    updateChart() {
      if (this.callLogs.length === 0) return;

      const dateGroups = {};
      
      this.callLogs.forEach(call => {
        const date = new Date(call.created_at).toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        });
        dateGroups[date] = (dateGroups[date] || 0) + 1;
      });

      const labels = Object.keys(dateGroups);
      const data = Object.values(dateGroups);

      this.renderChart(
        {
          labels,
          datasets: [{
            label: this.$t('CALL_LOG_REPORT.CHART.CALLS_BY_DATE'),
            data,
            backgroundColor: '#3b82f6',
            borderColor: '#1d4ed8',
            borderWidth: 1,
          }],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                ticks: {
                  autoSkip: false,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        }
      );
    },
  },
  watch: {
    callLogs: {
      immediate: true,
      handler() {
        if (this.callLogs.length > 0) this.updateChart();
      },
    },
  },
  mounted() {
    this.updateChart();
  },
};
</script>

<style scoped>
.bar-chart-container {
  position: relative;
  height: 400px;
  width: 100%;
}
</style>